import { Breadcrumb, Layout, Menu, Image, Row, Col, Button, Modal, Upload, Card, Input, Tabs, Typography, Checkbox, Table, Divider } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { EditOutlined, HeartOutlined, PlusOutlined } from '@ant-design/icons';

const RFIDRollCall = () => {
    const [title, setTitle] = useState('新增貼文');
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [data, setData] = useState([{
        img: '',
        title: '1111',
        content: '跳脫也使一種極限',
        date: '2022/12/31'
    }, {
        img: '',
        title: '1111',
        content: '跳脫也一種極限',
        date: '2022/12/31'
    }, {
        img: '',
        title: '1111',
        content: '跳脫也使一種極限',
        date: '2022/12/31'
    }, {
        img: '',
        title: '1111',
        content: '跳脫也使一種極限',
        date: '2022/12/31'
    }]);
    const handleOnEdit = (key) => {
        console.log(key);
        setTitle('修改貼文');
        setColor('f09a45');
        setEdit(true);
        data.map((value, index) => {
            if (index == key) {
                setEditCard(value);
            }
        })
        setOpen(true)
    }
    const handleOk = () => {
        setOpen(false);
    }
    return (
        <>


            {/* <Row className='row d-flex justify-content-between'>
                <Col>
                    111-1 英文衝刺班
                </Col>
                <Col>
                    <button style={{ color: '#6EA7DC', fontSize: '24px', letterSpacing: '0.1em' }} >+新增成員</button>
                </Col>
            </Row> */}
        
            <Row>
                RFID 雲端線上點名
            </Row>


            <Table
                dataSource={data}
                columns={[
                    {
                        title: '標號',
                        key: 'Pid',
                        dataIndex: 'Pid'
                    },
                    {
                        title: '相片',
                        key: 'Count_Exam',
                        dataIndex: 'Count_Exam'
                    },
                    {
                        title: '姓名',
                        key: 'Year',
                        dataIndex: 'Year'
                    },
                    {
                        title: '抵達時間',
                        key: 'StuName',
                        dataIndex: 'StuName'
                    },
                    {
                        title: 'RFID序號',
                        key: 'Sex',
                        dataIndex: 'Sex'
                    },
                    {
                        title: '通知狀態',
                        key: 'StuNum',
                        dataIndex: 'StuNum'
                    },
                ]}
                scroll={{ x: 'max-content' }}
                tableLayout='fixed'

            />
        </>
    )

}
export default RFIDRollCall;
